"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AWARD_MOMENT_DEFAULT_BACKGROUND_IMAGE = 'https://stories-api-public.s3.amazonaws.com/award-moment-background.jpg';
exports.default = AWARD_MOMENT_DEFAULT_BACKGROUND_IMAGE;